import React, {useEffect} from 'react';
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import BaseMutatePointMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/mutatePoint/BaseMutatePointMutateSingleVoyage";
import {
    useGetStateMutatePointMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/mutatePoint/hooks/useGetStateMutatePointMutateSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import {useTranslation} from "react-i18next";
import moment from "moment";
import {DATE_FORMAT_POINT_SINGLE_VOYAGE} from "@containers/singleVoyage/containers/points/constants/dateFormat";


interface IProps {
    targetPoint: IWayPointCreationWithCorrectionsSingleVoyage,
}

const MutatePointMutateWithHotUpdateSingleVoyage = ({targetPoint}: IProps) => {

    const {t} = useTranslation();

    const stateMutatePointMutateSingleVoyage = useGetStateMutatePointMutateSingleVoyage({initial: targetPoint})

    useEffect(() => {
        stateMutatePointMutateSingleVoyage.onChangeName(targetPoint.name)
        stateMutatePointMutateSingleVoyage.onChangeAddress(targetPoint.address)
        stateMutatePointMutateSingleVoyage.onChangeRadius(targetPoint.radius?.toString())
        stateMutatePointMutateSingleVoyage.onChangePlannedDeparture(targetPoint?.plannedDeparture ? moment(targetPoint?.plannedDeparture).format(DATE_FORMAT_POINT_SINGLE_VOYAGE) : null)
        stateMutatePointMutateSingleVoyage.onChangePlannedArrival(targetPoint?.plannedArrival ? moment(targetPoint?.plannedArrival || new Date()).format(DATE_FORMAT_POINT_SINGLE_VOYAGE) : null)
        stateMutatePointMutateSingleVoyage.onChangeHasPlannedDeparture(!!targetPoint.plannedDeparture)
        stateMutatePointMutateSingleVoyage.onChangeHasPlannedArrival(!!targetPoint.plannedArrival)
    }, [targetPoint]);

    const {setPoints} = useRootContextMutateSingleVoyage()

    const onSavePoint = (point: IWayPointCreationWithCorrectionsSingleVoyage) => {
        setPoints((prev) => {
            return prev.map((item) => {
                if (item.id.toString() === point.id.toString()) {
                    return point
                }
                return item
            })
        })
    }

    return (
        <BaseMutatePointMutateSingleVoyage
            initial={targetPoint}
            stateMutatePointMutateSingleVoyage={stateMutatePointMutateSingleVoyage}
            onSave={onSavePoint}
            btnLabel={t('base.saveChanges')}
        />
    );
};

export default MutatePointMutateWithHotUpdateSingleVoyage;
